/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-12-07 11:47:33
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import getTitle from '@/utils/get-title'
import store from '@/store'
import * as type from '@/store/action-types'
import { getCookie, setCookie } from '@/utils/cookies'
Vue.use(VueRouter)

let routes = []
const files = require.context('./modules/', false, /\.router.js$/)
files.keys().forEach(key => {
  const file = files(key).default || files(key)
  routes.push(...file)
})
const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  window.fromPath = from.path
  document.title = getTitle(to.meta.title)
  // if (to.path === '/login' || to.path === '/phoneLogin') return next()
  if (to.path === '/phoneLogin') {
    localStorage.setItem('redirect', router.currentRoute.fullPath)
  }
  if (to.query.token) {
    setCookie('myToken', to.query.token)
    store.commit(`user/${type.SET_TOKEN}`, to.query.token)
    store.dispatch(`user/${type.GET_USER_INFO}`)
    return next()
  }
  if (!getCookie('myToken')) {
    next()
    // next({
    //   path: '/login',
    //   query: {
    //     redirect: to.fullPath,
    //   },
    // })
  } else {
    // 重拿用户信息
    if (JSON.stringify(store.state.user.userInfo) == '{}') {
      const userInfo = getCookie('userInfo')
      JSON.stringify(userInfo) !== '{}' && store.commit(`user/${type.SET_USER_INFO}`, userInfo)
    }
    next()
  }
})

router.afterEach(() => {})

export default router
